<template>
    <div>
        <el-row v-if="isConfirmationSuccessfully" align="center" type="flex" class="row" v-loading="isLoading">
            <el-col class="vertical-center confirm-register-information" style="height: 100%">
                <h1 id="confirm_base_info_title">{{$t("register.confirmBaseInfoTitle")}}</h1>

                <el-row>
                    <div class="information-title-wrapper">
                        <p class="information-title">{{$t("register.nameTitle")}}</p>
                    </div>

                    <div class="information-value-wrapper">
                        <p class="information-value">{{endUserBaseInfo.name}}</p>
                    </div>
                </el-row>

                <el-row style="padding-top: 20px">
                    <div class="information-title-wrapper">
                        <p class="information-title">{{$t("register.birthDayTitle")}}</p>
                    </div>

                    <div class="information-value-wrapper">
                        <p class="information-value">{{endUserBaseInfo.birthDay}}</p>
                    </div>
                </el-row>

                <el-row style="padding-top: 20px">
                    <div class="information-title-wrapper">
                        <p class="information-title">{{$t("register.nationalTitle")}}</p>
                    </div>

                    <div class="information-value-wrapper">
                        <p class="information-value">{{endUserBaseInfo.national}}</p>
                    </div>
                </el-row>

                <el-row style="padding-top: 20px">
                    <div class="information-title-wrapper">
                        <p class="information-title">{{$t("register.genderTitle")}}</p>
                    </div>

                    <div class="information-value-wrapper">
                        <p class="information-value">{{endUserBaseInfo.gender}}</p>
                    </div>
                </el-row>

                <el-row style="padding-top: 20px">
                    <div class="information-title-wrapper">
                        <p class="information-title">{{$t("register.phoneTitle")}}</p>
                    </div>

                    <div class="information-value-wrapper">
                        <p class="information-value">{{endUserBaseInfo.phone}}</p>
                    </div>
                </el-row>

                <el-row style="padding-top: 20px">
                    <div class="information-title-wrapper" id="accept_email_title_wrapper">
                        <p class="information-title">{{$t("register.acceptEmailHeader")}}</p>
                    </div>

                    <div class="information-value-wrapper">
                        <p class="information-value">{{endUserBaseInfo.allowedToReceiveEmail}}</p>
                    </div>
                </el-row>

                <el-row style="padding-top: 20px">
                    <div class="information-title-wrapper" id="accept_system_rules_title_wrapper">
                        <p class="information-title">{{$t("register.acceptSystemRulesHeader")}}</p>
                    </div>

                    <div class="information-value-wrapper">
                        <p class="information-value">{{endUserBaseInfo.acceptRules}}</p>
                    </div>
                </el-row>

                <el-row v-if="isInformationWasNotRegistered">
                    <h4 style="color: red; text-align: center">{{$t("register.pleaseEnterInfoMessage")}}</h4>
                </el-row>

                <el-row class="activate-button" style="">
                    <el-button id="activate_button" v-bind:disabled="isDisabledSubmitButton" @click="activateEndUser">
                        {{$t("register.submitBaseInfoButton")}}
                    </el-button>
                </el-row>
            </el-col>
        </el-row>

        <el-row v-if="isExpiredOrPasswordWasNotConfirmed">
            <h2 style="color: red; text-align: center">{{$t("register.expiredOrInfoNotExactly")}}</h2>
        </el-row>
    </div>
</template>

<script>
    import UserAPI from "../../api/user/UserApi";
    import AlertService from "../../service/alert.service";
    import StorageManager from "../../security/StorageManager";

    export default {
        name: "ConfirmRegisterInformation",
        data() {
            return {
                endUserBaseInfo: {},
                username: "",
                userCode: "",
                isExpiredOrPasswordWasNotConfirmed: false,
                isConfirmationSuccessfully: false,
                isDisabledSubmitButton: false,
                isInformationWasNotRegistered: false,
                isLoading: false,
            }
        },

        created() {
            this.username = this.$route.query.username;
            this.userCode = this.$route.query.endUserCode
            console.log(this.userCode)
            console.log(this.username)
            this.endUserBaseInfo.code = this.userCode;
            console.log(this.userCode)
            let vm = this;

            UserAPI.getBaseInfoAndCheckConfirmationPasswordAndRegisterUnexpired(this.username, this.userCode).then(result => {
                console.log(result)
                if (result.passwordConfirmedAndUnexpired) {
                    vm.isConfirmationSuccessfully = true;
                    vm.isExpiredOrPasswordWasNotConfirmed = false;

                    if (result.endUserDto == null || result.endUserDto.name == null || result.endUserDto.name.trim() == "" ||
                        result.endUserDto.birthDay == null || result.endUserDto.birthDay.trim() == "" || result.endUserDto.gender == null
                        || result.endUserDto.gender.trim() == "" || result.endUserDto.national == null || result.endUserDto.national.trim == "") {
                        vm.isDisabledSubmitButton = true;
                        vm.isInformationWasNotRegistered = true;

                    } else {
                        let birthDay = new Date(result.endUserDto.birthDay)
                        vm.endUserBaseInfo = result.endUserDto;
                        vm.endUserBaseInfo.birthDay = birthDay.getFullYear() + "/" + (birthDay.getMonth() + 1) + "/" + birthDay.getDate();
                        vm.endUserBaseInfo.acceptRules = this.$t("register.acceptRuleValue");
                        vm.endUserBaseInfo.allowedToReceiveEmail = result.endUserDto.allowedToReceiveEmail ? this.$t("register.acceptEmailValue") : this.$t("register.dontAcceptEmailValue");
                        ;

                        if (result.endUserDto.gender == "MALE") {
                            vm.endUserBaseInfo.gender = this.$t("register.maleGender")
                        } else if (result.endUserDto.gender == "FEMALE") {
                            vm.endUserBaseInfo.gender = this.$t("register.femaleGender")
                        } else {
                            vm.endUserBaseInfo.gender = this.$t("register.otherGender")
                        }
                    }

                } else {
                    vm.isExpiredOrPasswordWasNotConfirmed = true;
                    vm.isConfirmationSuccessfully = false;
                    vm.endUserBaseInfo.acceptRules = "";
                    vm.endUserBaseInfo.allowedToReceiveEmail = ""
                }
            })
        },

        methods: {
            activateEndUser() {
                this.isLoading = true;
                UserAPI.activeEndUser(this.userCode).then(result => {
                    this.isLoading = false;
                    if (!result) {
                        AlertService.error(this.$t("register.registerFailed"))
                    } else {
                        AlertService.success(this.$t("register.registerSuccessfully"));

                        this.$auth.setCurrentUser(result.endUserEntity);

                        // redirect user after register successfully.
                        let requestUrl = StorageManager.getItem("requestUrl");
                        console.log("request url: " + requestUrl);
                        if (requestUrl != null && requestUrl != undefined) {
                            StorageManager.removeItem("requestUrl");
                            this.$router.push({path: requestUrl});
                        } else {
                            this.$router.push({path: "/myPage"});
                        }
                    }

                });
            }
        }
    }
</script>

<style scoped lang="scss">
    #confirm_base_info_title {
        font-weight: bold;
        text-align: center;
        font-size: 30px;
    }

    .confirm-register-information {
        margin-left: 30%;
        margin-right: 30%;
    }

    #activate_button {
        width: 250px;
        background-color: #4B86E8;
        color: white
    }

    .activate-button {
        padding-top: 30px;
        text-align: center
    }

    .information-title {
        margin-top: 10px;
        margin-left: 20px
    }

    .information-value {
        margin-top: 10px;
        margin-left: 40px;
        word-break: break-all;
    }

    .information-title-wrapper {
        width: 40%;
        float: left;
        background-color: #b4d7ff;
        min-height: 40px
    }

    .information-title-wrapper #accept_system_rules_title_wrapper {
        width: 40%;
        float: left;
        background-color: #b4d7ff;
        min-height: 40px
    }

    .information-title-wrapper #accept_email_title_wrapper {
        width: 40%;
        float: left;
        background-color: #b4d7ff;
        min-height: 40px
    }

    .information-value-wrapper {
        width: 60%;
        float: right;
    }

    @media screen and (max-width: 1024px) {
        .confirm-register-information {
            margin-left: 0%;
            margin-right: 0%;
        }

        .information-title-wrapper #accept_system_rules_title_wrapper {
            width: 40%;
            float: left;
            background-color: #b4d7ff;
            min-height: 40px
        }

        .information-title-wrapper #accept_email_title_wrapper {
            width: 40%;
            float: left;
            background-color: #b4d7ff;
            min-height: 40px
        }
    }

    @media screen and (max-width: 450px) {
        .confirm-register-information {
            margin-left: 0%;
            margin-right: 0%;
        }

        #confirm_base_info_title {
            font-weight: bold;
            text-align: center;
            font-size: 18px;
        }

        #accept_email_title_wrapper {
            width: 45%;
            float: left;
            background-color: #b4d7ff;
            min-height: 40px;
        }

        #accept_system_rules_title_wrapper {
            width: 45%;
            float: left;
            background-color: #b4d7ff;
            min-height: 40px;
        }

        .activate-button {
            padding-top: 30px;
        }

        .information-title {
            margin-left: 2px;
            margin-top: 10px;
        }

        .information-value {
            margin-top: 10px;
            margin-left: 10px
        }

        .information-title-wrapper {
            width: 45%;
            float: left;
            background-color: #b4d7ff;
            min-height: 40px
        }

        .information-value-wrapper {
            width: 55%;
            float: right;
        }

        #activate_button {
            width: 100%;
            background-color: #4B86E8;
            color: white
        }
    }

    @media screen and (max-width: 320px) {
        .information-title {
            margin-left: 2px;
            margin-top: 10px;
            font-size: 12px;
        }

        #confirm_base_info_title {
            font-weight: bold;
            text-align: center;
            font-size: 18px;
        }

        .information-value {
            margin-top: 10px;
            margin-left: 10px;
            font-size: 12px;
        }

        .information-title-wrapper {
            width: 45%;
            float: left;
            background-color: #b4d7ff;
            min-height: 40px
        }

        #accept_system_rules_title_wrapper {
            width: 45%;
            float: left;
            background-color: #b4d7ff;
            min-height: 40px;
        }

        #accept_email_title_wrapper {
            width: 45%;
            float: left;
            background-color: #b4d7ff;
            min-height: 40px;
        }

        .information-value-wrapper {
            width: 55%;
            float: right;
        }

        #activate_button {
            width: 100%;
            background-color: #4B86E8;
            color: white
        }
    }

    @media screen and (max-width: 375px) {
        #confirm_base_info_title {
            font-weight: bold;
            text-align: center;
            font-size: 18px;
        }

        .information-title {
            margin-left: 2px;
            margin-top: 10px;
            font-size: 14px;
        }

        .information-value {
            margin-top: 10px;
            margin-left: 10px;
            font-size: 14px;
        }

        .information-title-wrapper {
            width: 45%;
            float: left;
            background-color: #b4d7ff;
            min-height: 40px
        }

        .information-value-wrapper {
            width: 55%;
            float: right;
        }

        #activate_button {
            width: 100%;
            background-color: #4B86E8;
            color: white
        }
    }
</style>